export default __webpack_public_path__ + "static/media/uploader-roche-1.70911fec.png";